import React, { Component } from "react";

// Importing geolocated reducer function
import { geolocated } from "react-geolocated";
import API from "../../services/API";
import {toast} from "react-toastify";

class GetLocation extends Component {
    state = {
        position_is_available : 0,
    }
    showPosition  = (position) => {
        this.setState({position_is_available : 1 })
        window.localStorage.setItem("d-lat", position.coords.latitude);
        window.localStorage.setItem("d-lng", position.coords.longitude);
        let  request = {
            lat : position.coords.latitude,
            lng : position.coords.longitude
        }
        API.updatePosition(request)
            .then((response) => {
                //
            })
            .catch((error) => {
                toast.error(error.response.data.user_message);
            });
    }
    render() {
        return(<section className='container-fluid '>
            {this.state.position_is_available === 0 ?
            <div className="row mt-5 px-2">

                    <div className=" col-12 alert alert-danger no-geo max-w-lg super-small">
                        <button type="button" className="close float-left btn btn-outline-danger" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        عدم دسترسی به موقعیت مکانی

                        <span className="spinner-grow header-text float-right " role="status">

                        </span>

                    </div>

            </div>: ''
            }
        </section>)
    }
    componentDidMount = () =>{
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.showPosition);
        }
        setInterval (() => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.showPosition);
            }
            else {
                this.setState({position_is_available : 0 ,  time : 2000})
            }
        },300000)
       /* if(this.props.isGeolocationAvailable && this.props.isGeolocationEnabled && this.props.coords) {
            window.localStorage.setItem("d-lat", this.props.coords.latitude);
            window.localStorage.setItem("d-lng", this.props.coords.longitude);
                    let  request = {
                        lat : this.props.coords.latitude,
                        lng : this.props.coords.longitude
                    }
                    this.setState({position_is_available : 1})
                    API.updatePosition(request)
                        .then((response) => {
                            //
                        })
                        .catch((error) => {
                            toast.error(error.response.data.user_message);
                        });

        }

        setInterval (() => {
        if(this.props.isGeolocationAvailable && this.props.isGeolocationEnabled && this.props.coords) {
            window.localStorage.setItem("d-lat", this.props.coords.latitude);
            window.localStorage.setItem("d-lng", this.props.coords.longitude);
                    let  request = {
                        lat : this.props.coords.latitude,
                        lng : this.props.coords.longitude
                    }
                    this.setState({position_is_available : 1})
                    API.updatePosition(request)
                        .then((response) => {
                            //
                        })
                        .catch((error) => {
                            toast.error(error.response.data.user_message);
                        });

        }
        else {
            this.setState({position_is_available : 0})
        }
        },300000)*/
    }
}


export default geolocated()(GetLocation);
